module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Postal","short_name":"Postal","description":"Introducing a newly reimagined POSTAL, giving you the ability to capture formerly lost customers with monthly recalls sent to hard to reach patients via our direct mail service.","start_url":"/","background_color":"#663399","theme_color":"#fff","display":"standalone","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
